import { Accordion, AccordionItem } from '@heroui/react';
import type { ELightGalleryType } from '@quesmed/types/models';
import { AssetMarkdown } from '@/components';
import type { IAssetSchema } from '@/config/asset';
import { parseMarkdownSections } from '@/utils';

export const PreviewBrief = ({
  brief,
  lightgalleryType,
  assets,
  embedded,
}: {
  brief: string;
  lightgalleryType: ELightGalleryType;
  assets: IAssetSchema[];
  /** Omit outer scroll container when nested inside another preview layout */
  embedded?: boolean;
}) => {
  if (!brief) {
    return <div className='text-default-500 text-center py-4'>{'--'}</div>;
  }
  const sections = parseMarkdownSections(brief);

  const accordion = (
    <Accordion
      defaultExpandedKeys={sections.map((section) => section.title)}
      variant='splitted'
      className='space-y-2'
      selectionMode='multiple'
    >
      {sections.map((section, index) => (
        <AccordionItem
          classNames={{
            content: 'pt-0 border-t border-default-200',
            title: 'font-medium',
            base: 'shadow-none border border-default-200 rounded-md',
          }}
          key={section.title}
          title={`${index + 1}. ${section.title?.toUpperCase()}`}
        >
          <AssetMarkdown
            lightgalleryType={lightgalleryType}
            assets={assets}
            classNames={{ table: 'mb-2 mt-0' }}
            className='text-sm md:text-base'
          >
            {section.description}
          </AssetMarkdown>
        </AccordionItem>
      ))}
    </Accordion>
  );

  if (embedded) {
    return accordion;
  }

  return (
    <div className='px-1 h-full max-h-[calc(100dvh-310px)] overflow-y-auto scrollbar-thin scrollbar-thumb-default-200 scrollbar-track-default-100'>
      {accordion}
    </div>
  );
};
